var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":"news.title","bread-crumb-data":_vm.breadCrumbData}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-xl-6"},[_c('news-info-box')],1)]),_c('news-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }